import * as LucideIcons from "lucide-react";
import { Lightbulb } from "lucide-react";

export const DynamicIcon = ({ name, className }: { name?: string; className?: string }) => {
    if (!name) return <Lightbulb className={className} />;

    // Check if it's an image URL (starts with http or /)
    if (name.startsWith('http') || name.startsWith('/')) {
        return <img src={name} alt="icon" className={`${className} object-contain`} />;
    }

    const Icon = (LucideIcons as any)[name] || Lightbulb;
    return <Icon className={className} />;
};
